module.exports = __webpack_public_path__ + "images/Hotspot_Done.svg";